/** Money and decimal fields arrive as JSON numbers, but the generated types widen them to `any`. */
export const toNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const parsed = Number(value)

  return Number.isNaN(parsed) ? null : parsed
}
